import type {
  ChannelRecord,
  CreateChannelRequest,
  CreateChannelResponse,
  DeleteChannelResponse,
  ListChannelsResponse,
  UpdateChannelRequest,
  UpdateChannelResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

export function listChannels(
  fetchImpl: typeof fetch = fetch,
  query: { readonly brand?: string; readonly vendor?: string } = {},
): Promise<ListChannelsResponse> {
  const params = new URLSearchParams();
  if (query.brand !== undefined) params.set('brand', query.brand);
  if (query.vendor !== undefined) params.set('vendor', query.vendor);
  const qs = params.toString();
  return opsApiRequest<ListChannelsResponse>(
    `/v1/ops/channels${qs.length > 0 ? `?${qs}` : ''}`,
    { method: 'GET' },
    fetchImpl,
  );
}

export function createChannel(
  body: CreateChannelRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<CreateChannelResponse> {
  return opsApiRequest<CreateChannelResponse>('/v1/ops/channels', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body,
  }, fetchImpl);
}

export function updateChannel(
  id: string,
  body: UpdateChannelRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<UpdateChannelResponse> {
  return opsApiRequest<UpdateChannelResponse>(`/v1/ops/channels/${id}`, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body,
  }, fetchImpl);
}

export function deleteChannel(
  id: string,
  fetchImpl: typeof fetch = fetch,
): Promise<DeleteChannelResponse> {
  return opsApiRequest<DeleteChannelResponse>(`/v1/ops/channels/${id}`, {
    method: 'DELETE',
  }, fetchImpl);
}
